import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
	selector: 'app-menu-template1',
	templateUrl: './menu-template1.component.html',
	styleUrls: ['./menu-template1.component.scss'],
	providers: [Location],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuTemplate1Component implements OnInit {

  public year : number = Date.now();

  isNavbarCollapsed = true;
	constructor(public location: Location) { }

	ngOnInit() {
	}

  onOLClick() {
		window.open('http://www.confecamaras.org.co');
	}

}
